var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgInvitationtemplate = function SvgInvitationtemplate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "invitationtemplate_svg__Capa_1",
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "invitationtemplate_svg__st0",
    d: "M54 25.9H10c-4.4 0-8-3.6-8-8V10c0-4.4 3.6-8 8-8h44c4.4 0 8 3.6 8 8v7.9c0 4.5-3.6 8-8 8zM10 6.1c-2.2 0-4 1.8-4 4V18c0 2.2 1.8 4 4 4h44c2.2 0 4-1.8 4-4v-7.9c0-2.2-1.8-4-4-4H10zM14 62h-4c-4.4 0-8-3.6-8-8V39.2c0-4.4 3.6-8 8-8h4c4.4 0 8 3.6 8 8V54c0 4.4-3.6 8-8 8zm-4-26.9c-2.2 0-4 1.8-4 4v14.8c0 2.2 1.8 4 4 4h4c2.2 0 4-1.8 4-4V39.1c0-2.2-1.8-4-4-4h-4zM29 35.1c-1.1 0-2-.9-2-2s.9-2 2-2h31c1.1 0 2 .9 2 2s-.9 2-2 2H29zM60 44.1H29c-1.1 0-2-.9-2-2s.9-2 2-2h31c1.1 0 2 .9 2 2s-.9 2-2 2zM29 53c-1.1 0-2-.9-2-2s.9-2 2-2h31c1.1 0 2 .9 2 2s-.9 2-2 2H29zM60 62H29c-1.1 0-2-.9-2-2s.9-2 2-2h31c1.1 0 2 .9 2 2s-.9 2-2 2z"
  })));
};
export default SvgInvitationtemplate;